var map = {
	"./chrome.ico": 4986,
	"./deri.jpg": 1793,
	"./dk-portfolio.png": 7891,
	"./github.png": 566,
	"./linkedin.png": 6205,
	"./vscode.png": 3677,
	"./whatsapp.png": 9545,
	"./win-cmd.png": 2486,
	"./win-defender.png": 3145,
	"./win-file-explorer.ico": 4929,
	"./win-mail.png": 8509,
	"./win-search.ico": 6375,
	"./win-settings.ico": 2916,
	"./win-trash-empty.ico": 2393,
	"./win-trash-full.ico": 4719
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 771;